
import { ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { AuthService } from '../../auth.service';
import { RouterOutlet } from '@angular/router';

import { LayoutModule } from '@shared/directives/layout/layout.module';

@Component({
    selector: 'login.container.component',
    templateUrl: './login.container.component.html',
    styleUrls: ['./login.container.component.scss'],
    standalone: true,
    imports: [RouterOutlet, LayoutModule]
})

export class LoginContainerComponent implements OnInit {

    public shakeState = 'none';

    animationState = signal(false);

    constructor(
        public authService: AuthService,
        private cdr: ChangeDetectorRef
    ) {
        this.authService.loginError$.subscribe((error) => {
            if (error) {
                this.animateError();
            }
        });
    }

    animateError() {
        this.animationState.set(true);
        setTimeout(() => {
            this.animationState.set(false);
            this.cdr.markForCheck();
        }, 500);
    }



    ngOnInit(): void { }
}
